<template>
  <CBox
    class="skiniver-list"
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    minHeight="100vh"
    width="100%"
    overflowX="hidden"
  >
    <OmtLayoutContainer>
      <OmtRow v-if="error">
        <HealthListEmpty
          icon="magnifying-glass-waveform"
          :title="error"
          text="Tente novamente em alguns instantes."
        />
      </OmtRow>
      <OmtRow v-else-if="carregado && !cards.length">
        <HealthListEmpty
          icon="magnifying-glass-waveform"
          title="Nenhuma análise por aqui"
          text="Fotografe uma pinta, mancha ou lesão para receber a sua primeira análise."
        />
      </OmtRow>

      <template v-else-if="cards.length">
        <OmtRow mt="16px">
          <OmtTypography
            as="p2"
            color="var(--colors-light-primary-gray2)"
          >
            {{ cards.length }} {{ cards.length === 1 ? "análise" : "análises" }}
          </OmtTypography>
        </OmtRow>
        <OmtRow
          v-for="card in cards"
          :key="card.id"
          mt="12px"
        >
          <HealthRecordCard
            v-bind="card.props"
            @click="abrirDetalhe(card.id)"
          />
        </OmtRow>
      </template>

      <!-- A Skinive nao tem rodape: o botao fica colado na base da tela. O espaco reservado
           (2x) e maior que o botao fixo, para o ultimo cartao nunca ficar escondido atras dele. -->
      <FixedButtonRow
        :useFooter="false"
        fixedSize="2x"
      >
        <OmtButton
          :w="['100%', '308px !important']"
          @click="novaAnalise"
        >
          Nova análise
        </OmtButton>
      </FixedButtonRow>
    </OmtLayoutContainer>
  </CBox>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { CBox } from "@chakra-ui/vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import HealthListEmpty from "@/components/Organisms/Wellness/HealthListEmpty.vue";
import HealthRecordCard from "@/components/Organisms/Wellness/HealthRecordCard.vue";
import scrollbarVisivel from "@/mixins/scrollbarVisivel";

// CodigoStatus da analise: concluida ("C") ou em analise ("A").
const TOM_STATUS = {
  C: "success",
  A: "warning"
};

// RetornoFinal guarda a decisao da Plataforma Wellness inteira; o resumo fica em report.summary.
const resumoDoRelatorio = retornoFinal => {
  if (!retornoFinal) return "";
  try {
    return JSON.parse(retornoFinal)?.report?.summary || "";
  } catch (error) {
    return "";
  }
};

export default {
  name: "SkiniverList",
  components: { CBox, FixedButtonRow, HealthListEmpty, HealthRecordCard },
  mixins: [scrollbarVisivel],
  data() {
    return {
      carregado: false,
      error: null
    };
  },
  computed: {
    ...mapState("skiniver", ["chamados"]),
    cards() {
      return (this.chamados || []).map(c => ({
        id: c.Id,
        props: {
          title: `Protocolo ${c.ProtocoloANS || "-"}`,
          eyebrow: c.DataInclusao ? `Enviada em ${c.DataInclusao}` : "",
          description: resumoDoRelatorio(c.RetornoFinal) || "Nossa equipe de saúde está avaliando a imagem enviada.",
          image: c.Analise?.image_url || "",
          icon: "image",
          statusLabel: c.Status,
          statusTone: TOM_STATUS[c.CodigoStatus] || "neutral"
        }
      }));
    }
  },
  async mounted() {
    this.$root.$emit("show-loading");
    try {
      await this.listChamados();
    } catch (error) {
      console.error(error);
      this.error = "Serviço temporariamente indisponível";
    } finally {
      this.carregado = true;
      this.$root.$emit("hide-loading");
    }
  },
  methods: {
    ...mapActions("skiniver", ["listChamados"]),
    ...mapMutations("skiniver", {
      resetContext: "RESET_CONTEXT"
    }),
    abrirDetalhe(id) {
      this.$router.push({ name: "skiniver.detalhe", params: { id: String(id) } });
    },
    novaAnalise() {
      // Comeca a criacao sem resquicio de uma analise anterior.
      this.resetContext();
      this.$router.push({ name: "skiniver.inicio" });
    }
  }
};
</script>

<style scoped>
.skiniver-list ::v-deep .fixed-button {
  background-color: transparent;
}
</style>
